module.exports = __webpack_public_path__ + "static/media/lightningGamesPlayed_50000_100000.ddfc2fb9.png";